'use strict';

customerZone.run(['$rootScope', '$log', 'Session', 'OrderNotifications',
    function($rootScope, $log, Session, OrderNotifications){
        $rootScope.$on(Session.PROFILE_CHANGED_EVENT, function(profile){
            if (Session.authenticated()) {
                OrderNotifications.doCustomerChecks(profile.id)
                    .catch(function(error){
                        $log.error('Could not show order notifications', error);
                    });
            }
            else {
                OrderNotifications.hideNotifications();
            }
        });
    }]);
